import { useState, useEffect, useCallback } from "react";
import dayjs from "dayjs";
import api from "../services/api";

// ⚠️ Precisa ficar SINCRONIZADO com DIAS_ALERTA_VENCENDO em Passaporte.jsx —
// se você mudar um, mude o outro, senão a bolinha do menu e a tela de
// passaportes vão discordar sobre o que conta como "vencendo em breve".
const DIAS_ALERTA_VENCENDO = 180;

// Intervalo de repolling. Ajuste se useCheckinNotificacoes usar outro valor —
// não tenho acesso a esse arquivo pra confirmar, então mantive um padrão razoável.
const INTERVALO_MS = 5 * 60 * 1000; // 5 minutos

// ── Helpers (mesmo padrão usado em Passaporte.jsx) ────────────────────────
const extractRows = (data) => {
  if (!data) return [];
  if (data.FDBS) {
    try {
      const mgr    = data.FDBS.Manager ?? data.FDBS.manager;
      const tables = mgr?.TableList ?? mgr?.tablelist ?? [];
      if (tables.length > 0) {
        const rowList = tables[0].RowList ?? tables[0].rowlist ?? [];
        if (rowList.length > 0)
          return rowList.map((r) => r.Original ?? r.Current ?? r);
      }
    } catch (e) {}
  }
  if (data.Table && Array.isArray(data.Table)) return data.Table;
  if (Array.isArray(data)) return data;
  return [];
};

const normalize = (row) => {
  if (!row || typeof row !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(row)) out[k.toLowerCase()] = v;
  return out;
};

const parseDataSegura = (valor) => {
  if (!valor) return null;
  const tentativas = ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"];
  for (const fmt of tentativas) {
    const d = dayjs(valor, fmt, true);
    if (d.isValid()) return d;
  }
  const fallback = dayjs(valor);
  return fallback.isValid() ? fallback : null;
};

/**
 * Retorna { total, totalUrgente, vencidos, vencendo, loading, recarregar }.
 * total          = vencidos + vencendo em breve (o que a bolinha exibe)
 * totalUrgente   = só vencidos (define a cor vermelha vs laranja/azul)
 */
export function usePassaporteNotificacoes(userId) {
  const [passaportes, setPassaportes] = useState([]);
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      // 🔥 Rota assumida pelo mesmo padrão dos outros endpoints — confirme
      // se PesquisaPassaporte é o nome real da rota no seu roteamento.
      const res = await api.get("/ServerPrincipal/PesquisaPassaporte", { params: { Login: userId } });
      const rows = extractRows(res.data).map(normalize);
      setPassaportes(rows);
    } catch (e) {
      console.error("[usePassaporteNotificacoes] erro ao buscar passaportes:", e);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    carregar();
    const id = setInterval(carregar, INTERVALO_MS);
    return () => clearInterval(id);
  }, [carregar]);

  const hoje = dayjs().startOf("day");

  const vencidos = passaportes.filter((p) => {
    const d = parseDataSegura(p.por_dtvencimento);
    return d && d.startOf("day").isBefore(hoje);
  });

  const vencendo = passaportes.filter((p) => {
    const d = parseDataSegura(p.por_dtvencimento);
    if (!d) return false;
    const dias = d.startOf("day").diff(hoje, "day");
    return dias >= 0 && dias <= DIAS_ALERTA_VENCENDO;
  });

  return {
    total: vencidos.length + vencendo.length,
    totalUrgente: vencidos.length,
    vencidos,
    vencendo,
    loading,
    recarregar: carregar,
  };
}